// import agentStatusEnum from "./agentStatusEnum";

import filterTypeEnum from "../../../components/Filter/enumerations/filterTypeEnum";
import levelEnum from "../../../enumerations/levelEnum";
import { filterKeyOverview } from "./filterKeyEnum";
import overviewTimeEnum from "./overviewTimeEnum";

const filterSetupOverview = {
  //FILTER TYPE:
  // 1: with quick search
  // 2: only dropdowns
  filter_type: 2,

  filters: [
    {
      type: filterTypeEnum.SELECT,
      title: "overview",
      data_type: "grouped",
      data_index: `${filterKeyOverview.TIME}-${filterKeyOverview.LEVEL}`,
      items: [
        {
          title: "normal.searchSection",
          data_index: filterKeyOverview.TIME,
          type: filterTypeEnum.SELECT,
          required: true,
          //DATA TYPE: "static" and "api"
          //static is for fixed value, api is for data loaded from API
          //static: add static value_enum inside the setup file
          data_type: "static",
          value_enum: overviewTimeEnum,
        },
        {
          title: "normal.level",
          data_index: filterKeyOverview.LEVEL,
          type: filterTypeEnum.SELECT,
          required: true,
          //DATA TYPE: "static" and "api"
          //static is for fixed value, api is for data loaded from API
          //static: add static value_enum inside the setup file
          data_type: "static",
          value_enum: levelEnum.filter(
            (_level) =>
              !process.env.REACT_APP_REMOVED_LEVEL_FILTER?.split(",").includes(_level.value),
          ),
        },
      ],
    },
  ],
};

const filterSetupBetAmountOverview = {
  //FILTER TYPE:
  // 1: with quick search
  // 2: only dropdowns
  filter_type: 2,

  filters: [
    {
      type: filterTypeEnum.SELECT,
      title: "overview",
      data_type: "grouped",
      data_index: `${filterKeyOverview.TIME}-${filterKeyOverview.LEVEL}`,
      items: [
        {
          title: "normal.searchSection",
          data_index: filterKeyOverview.TIME,
          type: filterTypeEnum.SELECT,
          required: true,
          //DATA TYPE: "static" and "api"
          //static is for fixed value, api is for data loaded from API
          //static: add static value_enum inside the setup file
          data_type: "static",
          value_enum: overviewTimeEnum,
        },
        {
          title: "normal.level",
          data_index: filterKeyOverview.LEVEL,
          type: filterTypeEnum.SELECT,
          required: true,
          //DATA TYPE: "static" and "api"
          //static is for fixed value, api is for data loaded from API
          //static: add static value_enum inside the setup file
          data_type: "static",
          value_enum: levelEnum.filter(
            (_level) =>
              !process.env.REACT_APP_REMOVED_LEVEL_FILTER?.split(",").includes(_level.value),
          ),
        },
      ],
    },
  ],
};

export { filterSetupBetAmountOverview, filterSetupOverview };
